export const moneyPageFaqs = [
  {
    question: 'What is an AI receptionist for small business and how does it work?',
    answer: 'An AI receptionist is a virtual phone agent that answers inbound calls using a natural conversational voice. It learns your business information, answers common questions, qualifies leads, books appointments, and sends you the full call details automatically.'
  },
  {
    question: 'Will the AI sound robotic to my customers?',
    answer: 'No. AutoReception uses natural conversational pacing, interruptions, pauses, and human-like speech patterns. You can listen to the live demo before forwarding any calls.'
  },
  {
    question: 'Can AutoReception integrate with my existing scheduling software?',
    answer: 'Yes. AutoReception can connect with Google Calendar, Calendly, Cal.com, CRM platforms, Zapier, and custom workflows so appointments are booked against real availability.'
  },
  {
    question: 'What happens if a caller has an emergency or a question the AI cannot answer?',
    answer: 'You define the escalation rules. AutoReception can transfer urgent calls, collect detailed information for a callback, provide your emergency instructions, or politely explain that a team member will follow up.'
  },
  {
    question: 'Do I need to change my current business phone number?',
    answer: 'No. Keep your existing number. You can forward missed calls, after-hours calls, or every call to your dedicated AutoReception number in a few minutes.'
  },
  {
    question: 'How does pricing compare to hiring an in-house receptionist or live answering service?',
    answer: 'AutoReception costs significantly less than a full-time receptionist or a high-volume live answering service, while providing 24/7 availability, concurrent call handling, consistent answers, and automatic lead records.'
  }
];

export const comparisonRows = [
  ['Monthly Cost', '$699/month', '$1,500–$3,500/month', 'Low cost, high lost revenue'],
  ['Availability', '24/7/365', 'Business hours or scheduled shifts', 'No answering'],
  ['Concurrent Call Handling', 'Multiple calls at once', 'Usually one call at a time', 'One caller at a time'],
  ['Setup Time', 'About 5 minutes', 'Days to weeks', 'Immediate, but no intake'],
  ['Lead Retention Rate', 'Designed to capture every caller', 'Depends on staffing', 'Most callers hang up']
];

export const moneyPageSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'SoftwareApplication',
      name: 'AutoReception',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      description: 'A 24/7 AI receptionist and phone answering service for small businesses.',
      url: 'https://autoreception.net/ai-receptionist-for-small-business',
      offers: {
        '@type': 'Offer',
        price: '699',
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
        url: 'https://autoreception.net/ai-receptionist-for-small-business'
      },
      featureList: [
        '24/7 AI call answering',
        'Automated calendar booking',
        'Lead qualification',
        'Missed call text-back',
        'Call transcripts and CRM sync'
      ]
    },
    {
      '@type': 'FAQPage',
      mainEntity: moneyPageFaqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      }))
    }
  ]
};